import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { LoginRequestModel } from '../models/loginrequest.model';
import { LoginResultModel } from '../models/loginresult.model';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { ErrorService } from '../service/error.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(
    private errorService: ErrorService,
    private http: HttpClient,
    ) { }

    public login (loginRequestModel: LoginRequestModel): Observable<LoginResultModel> {
      return this.http.post<LoginResultModel>(environment.apiUrl + '/authentication', loginRequestModel)
        .pipe(
          catchError((error: any) => {

            let errorMessage = this.errorService.handleError(error)            
            return throwError(() => errorMessage);
          })
        );
    }  
}
